module.exports = __webpack_public_path__ + "static/1127348018.294b54f1.jpg";